import { ConfigService } from '@maia/config';
import { BaseService } from '@maia/feature-utils';
import { HttpService } from '@maia/httpClient';
import { ICmsProductDetailsEntity, ICmsProductIntroEntity } from '../../shared';

export class CmsService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async getProductIntro({ productGuid }: { productGuid: string }) {
    return await this.get<Array<ICmsProductIntroEntity>>(
      `products/${productGuid}/containers/product_intro`,
      'Get product intro',
    );
  }

  public async getProductDetails({ productGuid }: { productGuid: string }) {
    return await this.get<ICmsProductDetailsEntity>(
      `compositions/${productGuid}/containers/product_details`,
      'Get product details',
    );
  }
}
